import React from 'react';

interface HealthScoreCardProps {
  patientName: string;
  score: number;
  doctorNote: string;
}

const HealthScoreCard: React.FC<HealthScoreCardProps> = ({
  patientName,
  score,
  doctorNote
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      width: '242px'
    }}>
      {/* Patient Name Card */}
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '8px 12px',
        boxShadow: '0px 0px 5px 0px rgba(14, 124, 193, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        minHeight: '32px'
      }}>
        <span style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 300,
          fontSize: '10px',
          lineHeight: '2.954em', /* 29.54px / 10px = 2.954em */
          color: '#000000'
        }}>
          Khách hàng:
        </span>
        <span style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 800,
          fontSize: '10px',
          lineHeight: '2.954em', /* 29.54px / 10px = 2.954em */
          color: '#28A049'
        }}>
          {patientName}
        </span>
      </div>

      {/* Health Status Card */}
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '8px 12px',
        boxShadow: '0px 0px 5px 0px rgba(14, 124, 193, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        minHeight: '32px'
      }}>
        <span style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 300,
          fontSize: '10px',
          lineHeight: '2.954em', /* 29.54px / 10px = 2.954em */
          color: '#000000'
        }}>
          Tình trạng sức khỏe:
        </span>
        <span style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 800,
          fontSize: '10px',
          lineHeight: '2.954em', /* 29.54px / 10px = 2.954em */
          color: '#28A049'
        }}>
          {score}%
        </span>
      </div>

      {/* Doctor Assessment Card */}
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '8px 12px',
        boxShadow: '0px 0px 5px 0px rgba(14, 124, 193, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        minHeight: '32px'
      }}>
        <span style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 300,
          fontSize: '10px',
          lineHeight: '2.954em', /* 29.54px / 10px = 2.954em */
          color: '#000000'
        }}>
          Đánh giá của Bác sĩ:
        </span>
        <span style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 800,
          fontSize: '10px',
          lineHeight: '2.954em', /* 29.54px / 10px = 2.954em */
          color: '#28A049'
        }}>
          {doctorNote}
        </span>
      </div>

      {/* Health Scale Component */}
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '10px',
        boxShadow: '0px 0px 5px 0px rgba(14, 124, 193, 0.2)',
        minHeight: '86px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
      }}>
        <div style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 300,
          fontSize: '10px',
          lineHeight: '1.6em', /* 16px / 10px = 1.6em */
          textAlign: 'center',
          color: '#000000'
        }}>
          Thang đánh giá tình trạng sức khỏe
        </div>
        
        {/* Health Status Bars */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          width: '100%',
          justifyContent: 'center'
        }}>
          {/* Good Health */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: '50px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px'
            }}>
              <span style={{
                fontFamily: 'BT Beau Sans, Inter, sans-serif',
                fontWeight: 700,
                fontSize: '6px',
                lineHeight: '2.667em', /* 16px / 6px = 2.667em */
                textAlign: 'center',
                color: '#28A049'
              }}>
                Sức Khỏe Tốt
              </span>
              <div style={{
                width: '3px',
                height: '3px',
                backgroundColor: '#28A049',
                borderRadius: '64px'
              }} />
            </div>
            <div style={{
              width: '100%',
              height: '8px',
              backgroundColor: '#D0E2FF',
              borderRadius: '64px',
              position: 'relative'
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#28A049',
                borderRadius: '64px'
              }} />
            </div>
          </div>

          {/* Fair Health */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: '50px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px'
            }}>
              <span style={{
                fontFamily: 'BT Beau Sans, Inter, sans-serif',
                fontWeight: 700,
                fontSize: '6px',
                lineHeight: '2.667em', /* 16px / 6px = 2.667em */
                textAlign: 'center',
                color: '#007BC2'
              }}>
                Sức Khỏe Khá
              </span>
              <div style={{
                width: '3px',
                height: '3px',
                backgroundColor: '#007BC2',
                borderRadius: '64px'
              }} />
            </div>
            <div style={{
              width: '50px',
              height: '8px',
              backgroundColor: '#D0E2FF',
              borderRadius: '64px'
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#007BC2',
                borderRadius: '64px'
              }} />
            </div>
          </div>

          {/* Needs Attention */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: '50px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px'
            }}>
              <span style={{
                fontFamily: 'BT Beau Sans, Inter, sans-serif',
                fontWeight: 700,
                fontSize: '6px',
                lineHeight: '2.667em', /* 16px / 6px = 2.667em */
                textAlign: 'center',
                color: '#F37D42'
              }}>
                Cần Lưu Ý
              </span>
              <div style={{
                width: '3px',
                height: '3px',
                backgroundColor: '#F37D42',
                borderRadius: '64px'
              }} />
            </div>
            <div style={{
              width: '100%',
              height: '8px',
              backgroundColor: '#F37D42',
              borderRadius: '64px',
              paddingRight: '20px',
              position: 'relative'
            }}>
              <div style={{
                width: '56px',
                height: '100%',
                backgroundColor: '#F37D42',
                borderRadius: '64px'
              }} />
            </div>
          </div>

          {/* Close Monitoring */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: '50px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px'
            }}>
              <span style={{
                fontFamily: 'BT Beau Sans, Inter, sans-serif',
                fontWeight: 700,
                fontSize: '6px',
                lineHeight: '2.667em', /* 16px / 6px = 2.667em */
                textAlign: 'center',
                color: '#D20000'
              }}>
                Theo Dõi Sát
              </span>
              <div style={{
                width: '3px',
                height: '3px',
                backgroundColor: '#D20000',
                borderRadius: '64px'
              }} />
            </div>
            <div style={{
              width: '100%',
              height: '8px',
              backgroundColor: '#D20000',
              borderRadius: '64px'
            }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthScoreCard;
